import { Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { useLocalState, useSortingState } from "../../graphql/hooks";
import { SortingButton } from "../buttons/SortingButton";
import { TitleDropdown } from "../dropdowns/TitleDropdown";
import { SortingMode } from "../../models/types";
import { useApolloClient } from "@apollo/client";
import { updateDevelopmentSortingState } from "../../common/Helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faStar } from "@fortawesome/free-solid-svg-icons";
import styles from "./SortableTitles.module.scss";
import cx from "classnames";

export const SortableTitles = () => {
    const client = useApolloClient();
    const { developerMode } = useLocalState();
    const sortingState = useSortingState();

    const toggleChecked = () => {
        updateDevelopmentSortingState(
            client,
            sortingState.organizationSorting,
            !sortingState.favoritesSorting
        );
    };
    return (
        <Row className={`d-flex no-wrap ms-2 g-0 ${styles.headerRow}`}>
            <Col className={`${styles.titles} col-4 text-muted`}>
                {developerMode ? (
                    <OverlayTrigger
                        delay={{
                            show: 550,
                            hide: 100
                        }}
                        overlay={
                            sortingState.favoritesSorting ? (
                                <Tooltip>Release Favorites</Tooltip>
                            ) : (
                                <Tooltip>Favorites to Top</Tooltip>
                            )
                        }
                    >
                        <div
                            className={styles.starCheckbox}
                            onClick={toggleChecked}
                        >
                            <FontAwesomeIcon
                                icon={faStar}
                                className={
                                    sortingState.favoritesSorting
                                        ? styles.checked
                                        : styles.unchecked
                                }
                            />
                            {sortingState.favoritesSorting && (
                                <FontAwesomeIcon
                                    icon={faCheck}
                                    className={styles.checkMark}
                                />
                            )}
                        </div>
                    </OverlayTrigger>
                ) : null}
                <span
                    title="Products, projects and revisions"
                    className={styles.marginToCounterSuperscript}
                >
                    <TitleDropdown
                        title="Title"
                        sortingModes={[
                            SortingMode.NameAscending,
                            SortingMode.NameDescending
                        ]}
                    />
                </span>
                <SortingButton
                    sortingModes={[
                        SortingMode.NameAscending,
                        SortingMode.NameDescending
                    ]}
                />
            </Col>
            <Col className={cx(`${styles.titles} col-3 ps-3 text-muted`)}>
                <Form className="d-flex align-items-center">
                    <span className="text-subtle me-1">Organization</span>
                    {sortingState.organizationSorting && (
                        <span className={styles.AtoZ}>(A-Z)</span>
                    )}
                    <OverlayTrigger
                        delay={{ show: 550, hide: 100 }}
                        overlay={<Tooltip>Group by organizations</Tooltip>}
                    >
                        <Form.Check
                            type="checkbox"
                            id="organization-checkbox"
                            className="pe-2"
                            checked={sortingState.organizationSorting}
                            onChange={() =>
                                updateDevelopmentSortingState(
                                    client,
                                    !sortingState.organizationSorting,
                                    sortingState.favoritesSorting
                                )
                            }
                        ></Form.Check>
                    </OverlayTrigger>
                </Form>
            </Col>

            <Col
                className={`col-2 ${styles.titles} justify-content-center text-muted`}
            >
                <span
                    title="Last updated"
                    className={`d-flex nowrap ${styles.marginToCounterSuperscript}`}
                >
                    <TitleDropdown
                        title="Date"
                        sortingModes={[
                            SortingMode.DateAscending,
                            SortingMode.DateDescending
                        ]}
                    />
                </span>
                <SortingButton
                    sortingModes={[
                        SortingMode.DateAscending,
                        SortingMode.DateDescending
                    ]}
                />
            </Col>
            {developerMode && (
                <Col
                    title="Status badge contains number of projects"
                    className={cx(`${styles.titles} ps-3 text-subtle col-2`)}
                >
                    Status
                </Col>
            )}
            <Col className="col-1"></Col>
        </Row>
    );
};
